<template>
    <v-card class="mx-auto custom-card" v-bind="props">
        <v-list-item>
            <!--            <v-list-item-content>-->
            <div class="overline mb-0 custom-card__title">
                <slot name="card-title"></slot>
            </div>
            <!--            </v-list-item-content>-->
        </v-list-item>
        <div class="custom-card__body">
            <v-card-text>
                <slot name="card-body"></slot>
            </v-card-text>
        </div>
    </v-card>
</template>

<script>
export default {
    name: "CustomCard",
    props: {
        props: {
            type: Object,
            default: () => {},
        },
    },
};
</script>

<style lang="scss" scoped>
@use '@/styles/_index' as *;


.custom-card {
    padding-bottom: 10px;
    border: thin solid $border;
    border-radius: $border-radius;
    box-shadow: none !important;
    &__title {
        font-weight: 600;
    }
    &__body {
        padding-bottom: 10px;
    }
    .v-card__text {
        padding: 0 16px;
    }
}

.overline {
    font-size: 0.8rem !important;
    font-weight: 700;
    letter-spacing: 0.1666666667em !important;
    line-height: 2rem;
    text-transform: uppercase !important;
    font-family: Roboto, sans-serif !important;
    color: rgba(0, 0, 0, 0.87);
    padding: 8px 0;
}
</style>
